export default {"src":"/_next/static/media/0xcc42724c6683b7e57334c4e856f4c9965ed682bd.e11c0fc6.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};